
export default {

    setList(state, list) {
        state.list = list;
    },
    setOrder(state, order) {
        state.order = order;
    },
    removeOrder(state, orderId) {
        state.list = state.list.filter(item => item.id != orderId);
    }
}